export default (user, roles, adminoverride = true) => {
	if (adminoverride) {
		if (user.roles.includes('Admin')) {
			return true;
		}
	}
	for (const role of roles) {
		if (user.roles.includes(role)) {
			return true;
		}
	}
	return false;
};